ListComponent = require 'views/enterprise/dashboard/list-component'
InfiniteScroll = require 'views/lib/infinite-scroll'
SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
$ = require 'jquery'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_popover')
_ = require('underscore')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)
    @state = {
      items: @props.itemList.items()
      loadingState: @props.itemList.loadingState
    }

  _updateItemListState: (newItems) ->
    return unless @infiniteScroll
    @setState loadingState: @props.itemList.loadingState
    if newItems
      @setState items: @props.itemList.items()
      @infiniteScroll.reset()

  componentDidMount: ->
    # PopOver and InfiniteScroll are both jQuery selector based, so we have to
    # break React's nice separation of concerns to connect them and the
    # popover content.
    $po = $('.pop-over')
    $scrollableContainer = $('.pop-over-content', $po)
    $listElement = $scrollableContainer.children().first()
    @infiniteScroll = new InfiniteScroll $listElement,
      scrollableContainer: $scrollableContainer

    @infiniteScroll.on 'nearEnd', =>
      if @props.itemList.hasNextPage()
        @props.itemList.loadNextPage().then =>
          @_updateItemListState(true)
        @_updateItemListState()

    # InfiniteScroll needs to get element dimensions after PopOver renders
    $po.one 'is-shown', (e) =>
      @infiniteScroll?.reset()

  componentWillUnmount: ->
    @infiniteScroll?.destroy()
    delete @infiniteScroll
    if @term?.length > 0
      @props.itemList.updateFilter('search', '')

  onSearchTermChange: (term) =>
    @term = term
    @props.itemList.updateFilter('search', term).then =>
      @_updateItemListState(true)
    @_updateItemListState()

  render: t.renderable ->
    t.div =>
      t.addElement React.createElement SearchComponent,
        onChange: @onSearchTermChange
        placeholder: t.l(['search', @props.modelName])
        searchCount: @props.itemList.totalLength()
        debounce: true

      if @props.buttonData?
        t.addElement React.createElement @props.buttonData.componentClass,
          onClick: @props.buttonData.onClick

      t.div =>
        t.addElement React.createElement ListComponent,
          items: @state.items
          loadingState: @state.loadingState
          itemComponent: @props.itemComponent
          itemEventHandlers: @props.itemEventHandlers
          itemInlineButtons: @props.itemInlineButtons
          isPopOver: true



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/item-list-popover-component.coffee